export const APP_DETAILS = {
  FA_NAME: 'تلویکا',
  EN_NAME: 'Televika',
  AR_NAME: 'تلویکا',
  TJ_NAME: 'Televika',
  FA_DESCRIPTION: 'تلویکا تی وی',
  EN_DESCRIPTION: 'Televika TV',
  AR_DESCRIPTION: 'تلویکا تی وی',
  TJ_DESCRIPTION: 'Televika телевизион',
};

export const APP_API = {
  PROXY_URL: 'https://www.televika.com',
  API_PROTOCOL: 'https',
  API_SUBDOMAIN: 'www',
  API_BASE: 'televika.com',
  API_PATH: 'api',
  API_VERSION: 'v1',
};

export const APP_GLOBAL_CONFIG = {
  APP_VERSION: '2.2.3',
  ROWS_PER_PAGE: 5,
  GOOGLE_TAG_MANAGER: 'GTM-M99TGCJ',
  LOGIN_URL: 'https://televika.com/activate',
  APPS_URL: 'https://televika.com/app',
};
